// ABOUTME: The v28 horizon as a proportion of the space below the header, per step group and layout, and the deck fit.
// ABOUTME: Pure functions with no React; useHorizon.ts feeds them the viewport and the screen.

export const HEADER_HEIGHT_PX = 46;

// The prototype's horizon measured from the header's bottom edge at its two design frames
// (docs/plans/crossing/evidence/design-v28/deck-scene-measurements.md). 2A to 2D share `read`; 3A to 5C share `later`; any other screen id uses `read`.
const DESIGN = {
  desktop: { frameH: 810, read: 423, later: 410 },
  phone: { frameH: 844, read: 325, later: 316 },
} as const;

const LATER_SCREENS = new Set(['3A', '4A', '4B', '5B', '5C']);

// The horizon's y from the header's bottom edge, a proportion of (frameH - header) so it holds on other viewports.
export function horizonFor(screenId: string | undefined, phone: boolean, frameH: number): number {
  const design = phone ? DESIGN.phone : DESIGN.desktop;
  const designHz = screenId !== undefined && LATER_SCREENS.has(screenId) ? design.later : design.read;
  return Math.round((designHz / (design.frameH - HEADER_HEIGHT_PX)) * (frameH - HEADER_HEIGHT_PX));
}

// 390 / 1024 * 1.12 * 1024: the phone deck is 1.12 of a 390px-wide frame.
export const DECK_REFERENCE_WIDTH_PX = 436.8;
const DECK_ASSET_WIDTH_PX = 1024;

export interface DeckFit {
  scale: number;
  width: number;
  /** In viewport px (the header's 46px included). */
  top: number;
}

// SPEC 0 "Deck fit": the manu tips sit 55px above the horizon and, while the scale is not clamped, the bottom lands on the frame's.
export function deckFit(frameH: number, hz: number, phone: boolean): DeckFit {
  const scale = phone
    ? DECK_REFERENCE_WIDTH_PX / DECK_ASSET_WIDTH_PX
    : Math.min(1.6, Math.max(0.85, (frameH - HEADER_HEIGHT_PX - hz + 55) / 338));
  return { scale, width: DECK_ASSET_WIDTH_PX * scale, top: HEADER_HEIGHT_PX + hz - 55 - 337 * scale };
}
